// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"0494d4df","357":"488d5998","529":"4b8e8db1","791":"d582b1dd","852":"2d59a1ad","944":"cee56f9f"}[chunkId] + ".chunk.js";
};